export default "__VITE_ASSET__CCnJEfOW__"